import { AsyncPipe, SlicePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { ProductContextDirective } from 'ish-core/directives/product-context.directive';
import { CheckoutFacade } from 'ish-core/facades/checkout.facade';
import { HttpError } from 'ish-core/models/http-error/http-error.model';
import { LineItemView } from 'ish-core/models/line-item/line-item.model';
import { PriceItem } from 'ish-core/models/price-item/price-item.model';
import { PricePipe } from 'ish-core/models/price/price.pipe';
import { GenerateLazyComponent } from 'ish-core/utils/module-loader/generate-lazy-component.decorator';
import { BasketErrorMessageComponent } from 'ish-shared/components/basket/basket-error-message/basket-error-message.component';
import { BasketValidationResultsComponent } from 'ish-shared/components/basket/basket-validation-results/basket-validation-results.component';
import { ModalOptions } from 'ish-shared/components/common/modal-dialog/modal-dialog.component';
import { ProductImageComponent } from 'ish-shared/components/product/product-image/product-image.component';
import { ProductNameComponent } from 'ish-shared/components/product/product-name/product-name.component';
import { CustomEditLineItemComponent } from 'ish-shared/dias/components/basket/custom-edit-line-item/custom-edit-line-item.component';
import { CustomMiniCartRemoveItemConfirmationModalComponent } from 'ish-shared/dias/mini-cart/custom-mini-cart-remove-item-confirmation-modal/custom-mini-cart-remove-item-confirmation-modal.component';

@Component({
  selector: 'ish-mini-basket-content',
  templateUrl: './mini-basket-content.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    BasketErrorMessageComponent,
    BasketValidationResultsComponent,
    CustomEditLineItemComponent,
    CustomMiniCartRemoveItemConfirmationModalComponent,
    ProductContextDirective,
    ProductImageComponent,
    ProductNameComponent,
    RouterLink,
    AsyncPipe,
    SlicePipe,
    PricePipe,
    TranslateModule,
  ],
})
@GenerateLazyComponent()
export class MiniBasketContentComponent implements OnInit {
  private checkoutFacade = inject(CheckoutFacade);

  /**
   maximum number of displayed items, undefined = display always all items
   */
  maxItemNumber = 25;
  itemTotal$: Observable<PriceItem>;
  basketError$: Observable<HttpError>;
  lineItems$: Observable<LineItemView[]>;

  options: ModalOptions = { titleText: 'Remove Item', rejectText: 'Cancel', confirmText: 'Ok' };

  ngOnInit() {
    this.basketError$ = this.checkoutFacade.basketError$;
    this.lineItems$ = this.checkoutFacade.basketLineItems$;
    this.itemTotal$ = this.checkoutFacade.basketItemTotal$;
  }

  minicheckout() {
    this.checkoutFacade.start();
  }

  onDeleteItem(itemId: string) {
    this.checkoutFacade.deleteBasketItem(itemId);
  }
}
